module.exports = __webpack_public_path__ + "static/media/Snoman logo.bf0e8895.png";